import { Outlet } from 'react-router-dom';
import React, { lazy, useEffect } from 'react';
import { useGlobal } from '@@/contexts/GlobalProvider';

const GlobalHeader = lazy(() => import('@@/products/portal/components/global-header'));

const CloudscapeWrapper = () => {
  const { setColorScheme } = useGlobal();
  useEffect(() => {
    setColorScheme('cxportal');
  }, []);
  return (
    <>
      <GlobalHeader />
      <Outlet />
    </>
  );
};

export default CloudscapeWrapper;
